import { styled, Typography } from "@material-ui/core";
import { AdministrationApproach } from "elephant-web/gql";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import type { AddPrescriptionCardFieldNames } from "./add-prescription-card";
import {
  FrequentDosageInputs,
  HowLongForInputs,
} from "./frequent-dosage-inputs";

const Row = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const AdministrationDetailInputs: FC<{
  fieldNames: Pick<
    AddPrescriptionCardFieldNames,
    | "howItsTaken"
    | "doseValue"
    | "doseUnit"
    | "rateValue"
    | "rateUnit"
    | "howLongForValue"
    | "howLongForUnit"
    | "clinicalProductId"
  >;
}> = ({ fieldNames }) => {
  const { watch } = useFormContext();

  const administrationApproach = watch(
    fieldNames.howItsTaken,
  ) as AdministrationApproach;

  return (
    <div>
      <Row>
        <FrequentDosageInputs
          fieldNames={{
            doseValue: fieldNames.doseValue,
            doseUnit: fieldNames.doseUnit,
            rateValue: fieldNames.rateValue,
            rateUnit: fieldNames.rateUnit,
            clinicalProductId: fieldNames.clinicalProductId,
          }}
          administrationApproach={administrationApproach}
        />
      </Row>
      {(administrationApproach === AdministrationApproach.Outpatient ||
        administrationApproach === AdministrationApproach.AsRequired) && (
        <Row>
          <Typography variant="body1" style={{ marginBottom: 8 }}>
            <FormattedMessage
              id="prescription.how-long-for"
              defaultMessage="How long for"
            />
          </Typography>
          <HowLongForInputs
            fieldNames={{
              value: fieldNames.howLongForValue,
              unit: fieldNames.howLongForUnit,
            }}
          />
        </Row>
      )}
    </div>
  );
};
